/** Classification from a monthly punch (comprehensive `record` or lite `schedule_timing`). */
export function getPunchClassification(punch) {
  const c =
    punch?.record?.scheduleStatus?.classification ??
    punch?.record?.schedule_status?.classification ??
    punch?.schedule_timing?.classification;
  if (c != null && String(c).trim() !== "") return String(c).trim();
  return null;
}

/**
 * Primary classification for a day row: prefer last clock-out, then last clock-in,
 * then any punch with a classification (newest first).
 */
export function getDayClassificationStatus(dayRecord) {
  if (!dayRecord) return null;

  const punches = [...(dayRecord.punches || [])].sort(
    (a, b) => new Date(b?.occurred_at || 0) - new Date(a?.occurred_at || 0)
  );

  for (const actionType of ["CLOCK_OUT", "CLOCK_IN"]) {
    const punch = punches.find((p) => p?.action_type === actionType);
    const c = punch && getPunchClassification(punch);
    if (c) return c;
  }

  for (const punch of punches) {
    const c = getPunchClassification(punch);
    if (c) return c;
  }

  return null;
}

/** StatusDropdown key: classification when present, else action type. */
export function getPunchActivityStatus(punch) {
  const action = punch?.action_type || punch?.record?.actionType || null;
  const classification = getPunchClassification(punch);
  const isBreak = action === "BREAK_START" || action === "BREAK_END";

  if (isBreak && (!classification || classification === "NOT_APPLICABLE")) {
    return action;
  }
  if (classification && classification !== "NOT_APPLICABLE") {
    return classification;
  }
  return action;
}
